<template>
  <div id="vanber">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>推荐岗位</el-breadcrumb-item>
      <el-breadcrumb-item>岗位发布</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form class="formBox" ref="form" :model="form" :rules="rules" label-width="120px" @submit.native.prevent>
      <el-row>
        <el-col :span="12">
          <el-form-item label="职位名称" prop="job_name">
            <el-input v-model="form.job_name" placeholder="请输入职位名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="薪资待遇" prop="salary">
            <el-select v-model="form.salary_start" placeholder="最低薪资" class="w">
              <el-option v-for="item in $store.state.salaryList" :key="item.id" :label="item.value" :value="item.value"></el-option>
            </el-select>
            <el-select v-model="form.salary_end" placeholder="最高薪资" class="w">
              <el-option v-for="item in $store.state.salaryList" :key="item.id" :label="item.value" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="招聘人数" prop="recruitment">
            <el-input v-model="form.recruitment" placeholder="请输入人数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="食宿安排">
            <el-select v-model="form.food_bed" placeholder="选择食宿安排">
              <el-option v-for="item in $store.state.foodBedList" :key="item.id" :label="item.value" :value="Number(item.code)"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="学历要求">
            <el-select v-model="form.education_require">
              <el-option label="中专" :value="1"></el-option>
              <el-option label="大专" :value="2"></el-option>
              <el-option label="本科" :value="3"></el-option>
              <el-option label="研究生" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作城市" prop="city_id">
            <el-select placeholder="省" v-model="form.province_id" @change="provChange" class="w">
              <el-option v-for="item in $store.state.provinces" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-select placeholder="市" v-model="form.city_id" ref="city" class="w">
              <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="工作地点" prop="job_address" style="width: 100%;">
        <el-input v-model="form.job_address" placeholder="请输入详细地址"></el-input>
      </el-form-item>
      <el-form-item label="职位描述" prop="job_detail">
        <el-input v-model="form.job_detail" type="textarea" placeholder="请输入岗位描述" :rows="8"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人" prop="contact">
            <el-input v-model="form.contact" placeholder="请输入联系人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电话" prop="contact_phone">
            <el-input v-model="form.contact_phone" placeholder="请输入电话"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="邮箱">
            <el-input v-model="form.email" placeholder="请输入email"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item class="btn">
        <el-button type="primary" @click.prevent="onSubmit('form')">提交</el-button>
      </el-form-item>
    </el-form>

    <!-- <el-form ref="form" :model="form" :rules="rules" label-width="120px" class="formBox">
      <el-row>
        <el-col :span="12">
          <el-form-item label="职位名称" prop="job_name">
            <el-input v-model="form.job_name" placeholder="请输入职位名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职位类型" prop="job_type">
            <el-select v-model="form.job_type" placeholder="请选择职位类型">
              <el-option v-for="item in jobType" :key="item.id" :label="item.value" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="薪资待遇" prop="salary">
            <el-select v-model="form.salary_start" placeholder="最低薪资" class="w">
              <el-option v-for="item in salaryList" :key="item.id" :label="item.value" :value="item.value"></el-option>
            </el-select>
            <el-select v-model="form.salary_end" placeholder="最高薪资" class="w">
              <el-option v-for="item in salaryList" :key="item.id" :label="item.value" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="食宿安排">
            <el-select v-model="form.food_bed" placeholder="选择食宿安排">
              <el-option v-for="item in foodList" :key="item.id" :label="item.value" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="年龄要求">
            <el-select v-model="form.age_require">
              <el-option label="不限" value="不限"></el-option>
              <el-option label="18岁以上" value="18岁以上"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学历要求" prop="education">
            <el-select v-model="form.education" placeholder="请选择学历要求">
              <el-option v-for="item in educationList" :key="item.id" :label="item.value" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="招聘人数" prop="recruitment">
            <el-input v-model="form.recruitment" placeholder="请输入人数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作城市" prop="city_id">
            <el-select placeholder="省" v-model="form.province_id" @change="provChange" class="w">
              <el-option v-for="item in $store.state.provinces" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-select placeholder="市" v-model="form.city_id" ref="city" class="w">
              <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="工作地点" prop="job_address">
            <el-input v-model="form.job_address" placeholder="请输入详细地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="截止时间">
            <el-date-picker v-model="form.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间" class="w100"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="职位诱惑" prop="job_attraction">
        <el-input v-model="form.job_attraction" placeholder="请输入岗位亮点"></el-input>
      </el-form-item>
      <el-form-item label="职位描述" prop="job_detail">
        <el-input v-model="form.job_detail" type="textarea" placeholder="请输入岗位描述" style="width: 100%;"></el-input>
      </el-form-item>
      <el-row class="btn">
        <el-button type="primary" @click="onSubmit('form')">确认发布</el-button>
      </el-row>
    </el-form> -->

    <!--    <el-dialog title="提示" :visible.sync="tip" width="30%">-->
    <!--      <span style="font-size: 20px;line-height: 1.5;">签到岗位，每天有近千家院校十万学生，登录习讯云签到，在这里发布岗位您将直接获得精准推送。</span>-->
    <!--      <span slot="footer" class="dialog-footer">-->
    <!--        <el-button type="primary" @click="tip = false">确 定</el-button>-->
    <!--      </span>-->
    <!--    </el-dialog>-->
  </div>
</template>

<script>
import formatter from '@/assets/js/mixins/formatter';
import baseUrl from '@/api/baseUrl.js';
import axios from 'axios';
import qs from 'qs';
import E from 'wangeditor';

export default {
  mixins: [formatter],
  name: 'Editor',
  data() {
    let checkProvAndCity = (rule, value, callback) => {
      if (!value) {
        callback(new Error('省市必填'));
      } else if (!this.$refs.city.value) {
        callback(new Error('市级必填'));
      } else {
        callback();
      }
    };
    return {
      cityList: [],
      salaryList: [], // 岗位待遇
      foodList: [], //食宿安排情况
      jobType: [], //岗位类型
      educationList: [], // 学历类型
      // 验证规则
      rules: {
        job_name: [{ required: true, message: '请输入岗位', trigger: 'blur' }],
        city_id: [
          {
            required: true,
            validator: checkProvAndCity,
            trigger: ['blur', 'change']
          }
        ],
        job_address: [{ required: true, message: '请输入岗位详细地址', trigger: 'blur' }],
        job_type: [
          {
            required: true,
            message: '请选择岗位类型',
            trigger: ['blur', 'change']
          }
        ],
        education: [
          {
            required: true,
            message: '请选择学历要求',
            trigger: ['blur', 'change']
          }
        ],
        job_detail: [{ required: true, message: '请输入岗位描述', trigger: 'blur' }],
        job_attraction: [{ required: true, message: '请输入岗位吸引力', trigger: 'blur' }],
        request: [{ required: true, message: '请输入岗位要求', trigger: 'blur' }],
        recruitment: [
          {
            required: true,
            message: '请输入招聘人数',
            trigger: 'blur'
          }
        ],
        salary: [{ required: true, message: '请选择岗位待遇' }],
        expect_start: [
          {
            type: 'string',
            required: true,
            message: '请选择日期',
            trigger: 'change'
          }
        ],
        expect_end: [
          {
            type: 'string',
            required: true,
            message: '请选择日期',
            trigger: 'change'
          }
        ],
        contact: [{ required: true, message: '请输入联系人姓名' }],
        contact_phone: [
          { required: true, message: '请输入联系人手机号' },
          {
            pattern: /^1[0-9]{10}$/,
            message: '手机号格式不对',
            trigger: 'blur'
          }
        ],
      },
      form: {
        job_name: '', //岗位
        province_id: null,
        city_id: null,
        age_require: '',
        contact: '', //联系人
        email: '', //email
        contact_phone: '', //联系人电话
        job_address: '', //岗位详细地址
        job_detail: '', //岗位描述
        job_attraction: '', //岗位吸引力
        remark: '', //备注
        recruitment: '1', //招聘人数
        salary_start: '',
        salary_end: '',
        salary: '', //岗位待遇
        expect_start: '', //到岗时间
        expect_end: '', //过期时间
        food_bed: '', //食宿安排情况
        end_time: '', //截止时间
        job_type: '', // 岗位类型
        education_require: '' // 学历要求
      },
      tip: true,
      editor: null,
      editorContent: ''
    };
  },
  mounted() {
    this.jobType = this.$store.state.trades;
    this.educationList = this.$store.state.educations;
    if (this.$route.query.operate === 'update') {
      let job = JSON.parse(localStorage.getItem('job'));
      // console.log(job)
      if (job.province_id) {
        this.getXixunCity(job.province_id);
      }
      for (let key in this.form) {
        this.form[key] = job[key];
      }
      if (job.food_bed == 0) {
        this.form.food_bed = '';
      }
    } else {
      this.getAccountInfo()
    }
  },
  watch: {
    'form.recruitment'(newVal) {
      if (!/^[1-9]\d*$/.test(newVal)) {
        this.$message.error('请输入纯数字！');
        this.form.recruitment = '';
      }
    },
    'form.salary_start'(val) {
      if (val) {
        if (this.form.salary_end) {
          this.form.salary = `${val} ~ ${this.form.salary_end}`;
        } else {
          this.form.salary = `${val}`;
        }
      }
    },
    'form.salary_end'(val) {
      if (val && this.form.salary_start) {
        this.form.salary = `${this.form.salary_start} ~ ${val}`;
      }
    }
  },
  methods: {
    async getAccountInfo() {
      let { data } = await axios.get(`${baseUrl}/api/enterprise/business/info/get`, { withCredentials: true })
      if (data.code === 0) {
        this.form.contact = data.data[0].contact_name
        this.form.contact_phone = data.data[0].contact_mob
        this.form.email = data.data[0].contact_email
      }
    },
    // 创建富文本
    createEditor() {
      // 富文本
      this.editor = new E(this.$refs.editorElem);
      // 编辑器的事件，每次改变会获取其html内容
      this.editor.customConfig.onchange = html => {
        this.editorContent = html;
      };
      this.editor.customConfig.menus = [
        // 菜单配置
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'foreColor' // 文字颜色
      ];
      this.editor.create(); // 创建富文本实例
    },
    async getXixunCity(provinceId) {
      let res = await this.$api.common.getXixunCity(provinceId);
      // console.log(res.data);
      if (res.code === 0) {
        this.cityList = res.data;
      }
    },
    provChange(provId) {
      this.cityList = null;
      this.form.city_id = null;
      this.getXixunCity(provId);
    },
    onSubmit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          // this.form.job_detail = this.editor.txt.html();
          this.jobAdd();
        } else {
          return false;
        }
      });
    },
    async jobAdd() {
      let res = null;
      if (this.form.salary.indexOf('面议') == -1) {
        if (parseInt(this.form.salary_start.substring(0, this.form.salary_start.length - 1)) > parseInt(this.form.salary_end.substring(0, this.form.salary_end.length - 1))) {
          this.$message({
            message: '最低薪资不能大于最高薪资!',
            type: 'warning',
            center: true
          });
          return;
        }
      }
      let params = this.delNullVal(this.form);
      if (this.$route.query.operate === 'add') {
        res = await this.$api.job.addJobToSign(params);
      } else if (this.$route.query.operate === 'update') {
        let job = JSON.parse(localStorage.getItem('job'));
        params.id = job.id;
        res = await this.$api.job.editJobToSign(params);
      }

      if (res.code === 0) {
        if (this.$route.query.operate === 'add') {
          this.$message({
            message: '岗位发布成功!',
            type: 'success',
            center: true
          });

          // let params = {
          //   sign_job_id: res.data.id,
          //   subject: '万博云智招聘服务费',
          //   type: 'web'
          // };
          // axios.post(`${baseUrl}api/enterprise/pay/signJob/alipay/index`, qs.stringify(params), { withCredentials: true }).then(res => {
          //   const div = document.createElement('div');
          //   div.innerHTML = res.data;
          //   document.body.appendChild(div);
          //   document.forms[0].acceptCharset = 'GBK';
          //   document.forms['alipay_submit'].submit();
          // });
        } else if (this.$route.query.operate === 'update') {
          this.$message({
            message: '编辑成功!',
            type: 'success',
            center: true
          });
          this.$router.go(-1);
        }
      }
    },
    async pay(id) {
      let params = {
        sign_job_id: id,
        subject: '万博云智招聘服务费',
        type: 'web'
      };
      let res = await axios.post(`${baseUrl}api/enterprise/pay/signJob/alipay/index`, qs.stringify(params), { withCredentials: true });
      console.log(res);
      // const div = document.createElement('div')
      // div.innerHTML = res.data
      // document.body.appendChild(div)
      // document.forms[0].acceptCharset = 'GBK'
      // document.forms[0].submit()
      const div = document.createElement('div');
      div.innerHTML = res.data;
      document.body.appendChild(div);
      document.forms[0].acceptCharset = 'GBK'; //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
      document.forms[0].submit();
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .w-e-toolbar .w-e-menu {
  z-index: 15 !important;
}
/deep/ .w-e-text-container {
  position: relative;
  z-index: 10 !important;
}
#vanber {
  position: relative;
  padding: 20px;
  .formBox {
    width: 900px;
    margin: 40px auto;

    .el-row {
      margin-bottom: 0px;
    }

    .btn {
      padding-left: 50px;
      text-align: center;
      padding-top: 30px;
      .el-button {
        width: 286px;
      }
    }
    .el-select {
      width: 100%;
    }
    .w {
      width: 50%;
    }
    .w100 {
      width: 100%;
    }
  }
}
</style>
<style>
.el-textarea__inner {
  min-height: 120px !important;
}
</style>
